import { NavLink } from 'react-router-dom';
import { site } from '@/content/site';

const sections = [
  { to: '/blog',   label: 'Blog' },
  { to: '/resume', label: 'Resume' },
];

export function Nav() {
  return (
    <header className="border-b border-rule">
      <div className="max-w-page mx-auto px-4 sm:px-[var(--space-gutter)] py-5 flex items-center justify-between gap-4">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            [
              'no-underline flex items-center gap-2 font-display text-base sm:text-lg tracking-tight whitespace-nowrap transition-colors',
              isActive ? 'text-accent' : 'text-ink hover:text-accent',
            ].join(' ')
          }
        >
          <span className="seal" aria-hidden="true" />
          <span>{site.shortName}</span>
        </NavLink>

        <nav>
          <ul className="flex items-center gap-4 sm:gap-7">
            {sections.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      'label no-underline transition-colors',
                      isActive ? 'text-accent' : 'text-ink-muted hover:text-ink',
                    ].join(' ')
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
